import styled from '@emotion/styled'
import React from 'react'
import { colors } from '../../../../styles/variables'

export type SubmittedAsFilterValue = 'all' | 'personal' | 'organization' | 'other'

type Props = {
  value: SubmittedAsFilterValue
  onChange: (value: SubmittedAsFilterValue) => void
}

const SubmittedAsFilter: React.FC<Props> = ({ value, onChange }) => {
  return (
    <FilterContainer>
      <FilterLabel>Submitted as:</FilterLabel>
      <FilterSelect value={value} onChange={e => onChange(e.target.value as SubmittedAsFilterValue)}>
        <option value="all">All Submissions</option>
        <option value="personal">Personal</option>
        <option value="organization">Organization</option>
        <option value="other">Other</option>
      </FilterSelect>
    </FilterContainer>
  )
}

const FilterContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const FilterLabel = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: ${colors.grey};
`

const FilterSelect = styled.select`
  padding: 6px 12px;
  border: 1px solid ${colors.silver};
  border-radius: 6px;
  font-size: 14px;
  color: ${colors.grey};
  background: white;
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: ${colors.primaryColor};
  }
`

export default SubmittedAsFilter
